import Vue from 'vue'

Vue.config.productionTip = false;

export default {
    name : 'languageSwitcher',
    _selector : '#js_language-switcher',
    init() {
        const el = document.querySelector(this._selector);

        if (!el) {
            return false;
        }

        this.run();
    },

    run() {
        new Vue({
            el: this._selector,

            delimiters: ['@{', '}'],

            data :
            {
                actionUrl  : "",
                toggled : false,
            },

            computed : {
                showDialog()
                {
                    return this.toggled;
                }
            },

            methods:
            {
                toggleDialog()
                {
                    this.toggled = ! this.toggled;
                },

                maybeCloseDialog(event)
                {
                    if (event.target.classList.contains('dialog')) {
                        this.toggled = false;
                    }
                }
            },
            created ()
            {
                const activeLang = document.querySelector('.language-switcher__select [data-active]');

                if( activeLang) {
                    this.actionUrl = activeLang.value;
                }
            }

      });

    }
}